/**
 * Auto-registration module for slug cell renderers.
 * Import this file to register all slug-based cell renderer overrides.
 */
import { registerOrderSideSlugRenderer } from './orderSide';

// Register all slug cell renderers
registerOrderSideSlugRenderer();

// Export a marker to indicate registration is complete
export const SLUG_CELL_RENDERERS_REGISTERED = true;
